import { createSelector } from '@reduxjs/toolkit';
import { tasksNotDeleted } from './tasks-not-deleted';

export const tasksNotDeletedAndNotLocked = createSelector(tasksNotDeleted, (tasks) => tasks.filter((t) => !t.locked));
